module.exports = __webpack_public_path__ + "img/mature.00095f03.svg";